
(function(){
function sgProcess(d,W,H,v,c){
  var n=W*H,i,S2L=sgProcess.S2L,LUT=sgProcess.LUT;
  var wb=.30,ad=.45,r=Math.pow(c[0],1-wb),g=Math.pow(c[1],1-wb),b=Math.pow(c[2],1-wb),ln=.2126*r+.7152*g+.0722*b;
  var k=v*Math.pow(v,-ad),mr=k*r/ln,mg=k*g/ln,mb=k*b/ln;
  var R=new Float32Array(n),G=new Float32Array(n),B=new Float32Array(n),L=new Float32Array(n);
  for(i=0;i<n;i++){
    var a=S2L[d[4*i]]*mr,e=S2L[d[4*i+1]]*mg,f=S2L[d[4*i+2]]*mb;
    a=a/(1+.25*a)*1.25;e=e/(1+.25*e)*1.25;f=f/(1+.25*f)*1.25;
    R[i]=a;G[i]=e;B[i]=f;L[i]=Math.log(.2126*a+.7152*e+.0722*f+1e-4);
  }
  var s=W/1672,b1=sgBlur(L,W,H,40*s),b2=sgBlur(L,W,H,10*s),b3=sgBlur(L,W,H,3*s);
  for(i=0;i<n;i++){
    var y=L[i],gn=Math.exp(.75*(.9*(y-b1[i])+.9*(y-b2[i])+.6*(y-b3[i])));
    var q=R[i]*gn;q=q<0?0:q>1?1:q;d[4*i]=LUT[(q*8191+.5)|0];
    q=G[i]*gn;q=q<0?0:q>1?1:q;d[4*i+1]=LUT[(q*8191+.5)|0];
    q=B[i]*gn;q=q<0?0:q>1?1:q;d[4*i+2]=LUT[(q*8191+.5)|0];
  }
}
sgProcess.S2L=new Float32Array(256);
for(var i=0;i<256;i++){var x=i/255;sgProcess.S2L[i]=x<=.04045?x/12.92:Math.pow((x+.055)/1.055,2.4);}
sgProcess.LUT=new Uint8ClampedArray(8192);
for(i=0;i<8192;i++){var x=i/8191,s=x<=.0031308?x*12.92:1.055*Math.pow(x,1/2.4)-.055;s=s+.12*(s-.5)*(1-Math.abs(2*s-1));s=s<0?0:s>1?1:s;sgProcess.LUT[i]=Math.round(s*255);}
function sgBlur(src,W,H,sigma){
  var r=Math.max(1,Math.round((Math.sqrt(4*sigma*sigma+1)-1)/2)),a=new Float32Array(src),t=new Float32Array(src.length),p;
  for(p=0;p<3;p++){sgH(a,t,W,H,r);sgV(t,a,W,H,r);}
  return a;
}
function sgH(s,d,W,H,r){var inv=1/(2*r+1),y,x,o,acc;
  for(y=0;y<H;y++){o=y*W;acc=s[o]*(r+1);for(x=0;x<r;x++)acc+=s[o+Math.min(x,W-1)];
    for(x=0;x<W;x++){acc+=s[o+Math.min(x+r,W-1)]-s[o+Math.max(x-r-1,0)];d[o+x]=acc*inv;}}}
function sgV(s,d,W,H,r){var inv=1/(2*r+1),y,x,acc;
  for(x=0;x<W;x++){acc=s[x]*(r+1);for(y=0;y<r;y++)acc+=s[Math.min(y,H-1)*W+x];
    for(y=0;y<H;y++){acc+=s[Math.min(y+r,H-1)*W+x]-s[Math.max(y-r-1,0)*W+x];d[y*W+x]=acc*inv;}}}
window.sgProcess=sgProcess;})();
(function(){
  var sec=document.querySelector('[data-sg-lc]');
  if(!sec) return;
  var box=sec.querySelector('.sg-lc__box'),rg=sec.querySelector('[data-r]');
  var base=sec.querySelector('[data-base]'),cv=sec.querySelector('[data-cv]'),done=false;
  rg.addEventListener('input',function(){box.style.setProperty('--pos',rg.value+'%');});
  function paint(){
    if(done||!base.complete||!base.naturalWidth)return;
    var W=1100,H=Math.round(W*base.naturalHeight/base.naturalWidth);
    try{
      cv.width=W;cv.height=H;
      var ctx=cv.getContext('2d',{willReadFrequently:true});
      ctx.drawImage(base,0,0,W,H);
      var id=ctx.getImageData(0,0,W,H);
      sgProcess(id.data,W,H,.175,[1,1,1]);
      ctx.putImageData(id,0,0);
      done=true;cv.style.opacity='1';
    }catch(e){sec.hidden=true;}
  }
  cv.style.opacity='0';
  base.addEventListener('load',paint);
  paint();
})();
